const ArrowRight = "M8 16.59L12.5802 12 8 7.41 9.41 6l6 6-6 6L8 16.59z";

export default ArrowRight;
